// extracted by mini-css-extract-plugin
export var card_left_wrapper = "productGrid-module--card_left_wrapper--88702";
export var card_right_wrapper = "productGrid-module--card_right_wrapper--b536e";
export var product_grid_section = "productGrid-module--product_grid_section--f9060";